export const translations = {
  fa: {
    dir: "rtl",
    lang: "fa",
    fontFamily: "'Vazirmatn', 'Tahoma', sans-serif",

    // General
    appName: "TradePortal",
    tagline: "پلتفرم سفارش‌گیری بین‌المللی",
    loading: "در حال بارگذاری...",
    save: "ذخیره",
    cancel: "انصراف",
    delete: "حذف",
    edit: "ویرایش",
    add: "افزودن",
    search: "جستجو",
    filter: "فیلتر",
    all: "همه",
    confirm: "تأیید",
    back: "بازگشت",
    logout: "خروج",
    submit: "ارسال",
    close: "بستن",
    yes: "بله",
    no: "خیر",
    actions: "عملیات",
    status: "وضعیت",
    date: "تاریخ",
    total: "مجموع",
    price: "قیمت",
    quantity: "تعداد",
    unit: "واحد",
    category: "دسته‌بندی",
    description: "توضیحات",
    name: "نام",
    email: "ایمیل",
    password: "رمز عبور",
    phone: "تلفن",
    address: "آدرس",
    notes: "یادداشت",
    noData: "داده‌ای یافت نشد",
    required: "این فیلد الزامی است",

    // Auth
    signIn: "ورود به حساب",
    welcomeBack: "خوش آمدید",
    loginSubtitle: "برای ورود اطلاعات خود را وارد کنید",
    forgotPassword: "فراموشی رمز عبور",
    noAccount: "حساب کاربری ندارید؟ با نماینده فروش تماس بگیرید.",
    adminLogin: "ورود ادمین",
    customerLogin: "ورود مشتری",

    // Role
    admin: "مدیر",
    customer: "مشتری",
    selectRole: "نقش خود را انتخاب کنید",

    // Dashboard
    dashboard: "داشبورد",
    welcome: "خوش آمدید",
    ordersThisMonth: "سفارش این ماه",
    totalSpend: "مجموع خرید",
    inTransit: "در راه",
    onTimeRate: "به موقع",
    quickActions: "دسترسی سریع",
    recentOrders: "سفارش‌های اخیر",
    browseCatalog: "مرور کالاها",
    newOrder: "سفارش جدید",
    trackShipment: "پیگیری مرسوله",
    invoices: "فاکتورها",
    products: "محصولات",
    totalProducts: "کل محصولات",
    totalOrders: "کل سفارش‌ها",
    totalCustomers: "کل مشتریان",
    pendingOrders: "در انتظار بررسی",
    revenue: "درآمد",
    monthlyRevenue: "درآمد این ماه",
    manageProducts: "مدیریت محصولات",
    manageOrders: "مدیریت سفارش‌ها",
    manageCustomers: "مدیریت مشتریان",

    // Products
    productCatalog: "کاتالوگ محصولات",
    addProduct: "افزودن محصول",
    editProduct: "ویرایش محصول",
    productName: "نام محصول",
    sku: "کد SKU",
    moq: "حداقل سفارش (MOQ)",
    stock: "موجودی",
    leadTime: "زمان تحویل",
    certifications: "گواهینامه‌ها",
    specifications: "مشخصات فنی",
    addSpec: "افزودن مشخصه",
    specKey: "عنوان",
    specValue: "مقدار",
    inStock: "موجود",
    outOfStock: "ناموجود",
    pcsAvailable: "عدد موجود",
    swipeHint: "← رد کردن  |  افزودن به سبد →",
    addToCart: "افزودن به سبد",
    skip: "رد کردن",
    details: "جزئیات",
    productOf: "محصول {0} از {1}",
    addedToCart: "به سبد اضافه شد ✓",
    categories: {
      all: "همه",
      electronics: "الکترونیک",
      cables: "کابل",
      batteries: "باتری",
      accessories: "لوازم جانبی",
      other: "سایر",
    },

    // Order
    cart: "سبد خرید",
    order: "سفارش",
    placeOrder: "ثبت سفارش",
    orderSummary: "خلاصه سفارش",
    shippingDetails: "اطلاعات ارسال",
    deliveryAddress: "آدرس تحویل",
    shippingMethod: "روش ارسال",
    subtotal: "جمع کل",
    shipping: "هزینه ارسال",
    tax: "مالیات",
    free: "رایگان",
    itemsInCart: "آیتم در سبد",
    emptyCart: "سبد خرید خالی است",
    orderPlaced: "سفارش ثبت شد!",
    orderSuccess: "سفارش شما دریافت شد و در حال پردازش است.",
    orderRef: "شماره سفارش",
    backToDashboard: "بازگشت به داشبورد",
    specialInstructions: "دستورالعمل خاص، شماره مرجع...",
    shippingOptions: {
      standard: "استاندارد (۵–۷ روز) — رایگان",
      express: "اکسپرس (۲–۳ روز) — €45",
      freight: "باربری (۱۰–۱۴ روز) — €20",
    },

    // Order Status
    statusShipped: "ارسال شده",
    statusProcessing: "در حال پردازش",
    statusDelivered: "تحویل داده شده",
    statusPending: "در انتظار",
    statusCancelled: "لغو شده",

    // Admin
    adminPanel: "پنل مدیریت",
    customers: "مشتریان",
    addCustomer: "افزودن مشتری",
    editCustomer: "ویرایش مشتری",
    companyName: "نام شرکت",
    country: "کشور",
    contactPerson: "نام مسئول",
    customerCode: "کد مشتری",
    orderHistory: "تاریخچه سفارش‌ها",
    viewDetails: "مشاهده جزئیات",
    updateStatus: "به‌روزرسانی وضعیت",
    items: "آیتم",
  },

  ar: {
    dir: "rtl",
    lang: "ar",
    fontFamily: "'Cairo', 'Tahoma', sans-serif",

    appName: "TradePortal",
    tagline: "منصة الطلبات الدولية",
    loading: "جارٍ التحميل...",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    add: "إضافة",
    search: "بحث",
    filter: "تصفية",
    all: "الكل",
    confirm: "تأكيد",
    back: "رجوع",
    logout: "تسجيل الخروج",
    submit: "إرسال",
    close: "إغلاق",
    yes: "نعم",
    no: "لا",
    actions: "إجراءات",
    status: "الحالة",
    date: "التاريخ",
    total: "الإجمالي",
    price: "السعر",
    quantity: "الكمية",
    unit: "وحدة",
    category: "الفئة",
    description: "الوصف",
    name: "الاسم",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    phone: "الهاتف",
    address: "العنوان",
    notes: "ملاحظات",
    noData: "لا توجد بيانات",
    required: "هذا الحقل مطلوب",

    signIn: "تسجيل الدخول",
    welcomeBack: "مرحباً بعودتك",
    loginSubtitle: "أدخل بياناتك للمتابعة",
    forgotPassword: "نسيت كلمة المرور؟",
    noAccount: "ليس لديك حساب؟ تواصل مع مندوب المبيعات.",
    adminLogin: "دخول المشرف",
    customerLogin: "دخول العميل",

    admin: "مشرف",
    customer: "عميل",
    selectRole: "اختر دورك",

    dashboard: "لوحة التحكم",
    welcome: "مرحباً",
    ordersThisMonth: "طلبات هذا الشهر",
    totalSpend: "إجمالي الإنفاق",
    inTransit: "في الطريق",
    onTimeRate: "معدل الالتزام",
    quickActions: "الإجراءات السريعة",
    recentOrders: "الطلبات الأخيرة",
    browseCatalog: "تصفح الكتالوج",
    newOrder: "طلب جديد",
    trackShipment: "تتبع الشحنة",
    invoices: "الفواتير",
    products: "المنتجات",
    totalProducts: "إجمالي المنتجات",
    totalOrders: "إجمالي الطلبات",
    totalCustomers: "إجمالي العملاء",
    pendingOrders: "طلبات معلقة",
    revenue: "الإيرادات",
    monthlyRevenue: "إيرادات الشهر",
    manageProducts: "إدارة المنتجات",
    manageOrders: "إدارة الطلبات",
    manageCustomers: "إدارة العملاء",

    productCatalog: "كتالوج المنتجات",
    addProduct: "إضافة منتج",
    editProduct: "تعديل المنتج",
    productName: "اسم المنتج",
    sku: "رمز SKU",
    moq: "الحد الأدنى للطلب",
    stock: "المخزون",
    leadTime: "مدة التسليم",
    certifications: "الشهادات",
    specifications: "المواصفات التقنية",
    addSpec: "إضافة مواصفة",
    specKey: "العنوان",
    specValue: "القيمة",
    inStock: "متوفر",
    outOfStock: "غير متوفر",
    pcsAvailable: "قطعة متاحة",
    swipeHint: "← تخطي  |  إضافة للسلة →",
    addToCart: "إضافة للسلة",
    skip: "تخطي",
    details: "التفاصيل",
    productOf: "منتج {0} من {1}",
    addedToCart: "تمت الإضافة للسلة ✓",
    categories: {
      all: "الكل",
      electronics: "إلكترونيات",
      cables: "كابلات",
      batteries: "بطاريات",
      accessories: "إكسسوارات",
      other: "أخرى",
    },

    cart: "سلة التسوق",
    order: "الطلب",
    placeOrder: "تأكيد الطلب",
    orderSummary: "ملخص الطلب",
    shippingDetails: "تفاصيل الشحن",
    deliveryAddress: "عنوان التسليم",
    shippingMethod: "طريقة الشحن",
    subtotal: "المجموع الفرعي",
    shipping: "الشحن",
    tax: "الضريبة",
    free: "مجاني",
    itemsInCart: "عناصر في السلة",
    emptyCart: "السلة فارغة",
    orderPlaced: "تم تقديم الطلب!",
    orderSuccess: "تم استلام طلبك وهو قيد المعالجة.",
    orderRef: "رقم الطلب",
    backToDashboard: "العودة للوحة التحكم",
    specialInstructions: "تعليمات خاصة، أرقام مرجعية...",
    shippingOptions: {
      standard: "قياسي (5–7 أيام) — مجاني",
      express: "سريع (2–3 أيام) — €45",
      freight: "شحن بضائع (10–14 يوم) — €20",
    },

    statusShipped: "تم الشحن",
    statusProcessing: "قيد المعالجة",
    statusDelivered: "تم التسليم",
    statusPending: "في الانتظار",
    statusCancelled: "ملغى",

    adminPanel: "لوحة الإدارة",
    customers: "العملاء",
    addCustomer: "إضافة عميل",
    editCustomer: "تعديل العميل",
    companyName: "اسم الشركة",
    country: "الدولة",
    contactPerson: "الشخص المسؤول",
    customerCode: "كود العميل",
    orderHistory: "سجل الطلبات",
    viewDetails: "عرض التفاصيل",
    updateStatus: "تحديث الحالة",
    items: "عناصر",
  },
};
